<template>
    <VideoTutorial/>
</template>

<script>
    import VideoTutorial from '../components/Video_tutorial';

    export default {
        name: 'Tutorial',

        components: {
            VideoTutorial
        },
    };
</script>
